import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { ReviewService } from 'src/app/services/common/review.service';
import { DeleteBoxComponent } from '../../delete-box/delete-box.component';

@Component({
  selector: 'app-complete-review',
  templateUrl: './complete-review.component.html',
  styleUrls: ['./complete-review.component.scss']
})
export class CompleteReviewComponent {

  selectedDocs: any[] = [];
  @Input() public Content: any;
  content: any;
  ReviewId: any;
  appCode:any;

  constructor(
    private reviewService: ReviewService,
    private commonService: CommonService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    if (this.Content.content !== null) {
      if (this.Content.content.ReviewId != null && this.Content.content.ReviewId != "" && this.Content.content.ReviewId != undefined) {
        this.ReviewId = this.Content.content.ReviewId;
        this.appCode= this.Content.content.applicationCode;
        this.GetReviewDocuments();
      }
    }
  }

  GetReviewDocuments() {
    this.reviewService.GetReviewDocments("api/Review/ReviewDocments?Id=" + this.ReviewId).subscribe((result: any[]) => {
      if (result) {
        this.selectedDocs = [];
        this.selectedDocs = result["lstRevDocuments"];
      }
    });
  }

  close(){ 
    this.modalRef.close('yes');    
   }

  ResolveComments(DocID: any) {
    this.commonService.OnlyOfficePopupLanch(DocID, this.ReviewId).subscribe(res=>{
      this.GetReviewDocuments();
     });  
  }

  TaskComplete(DocId: any, documentname: any, reviewtitle: any) {
    this.reviewService.CheckIsLastTaskComplete("api/Review/CheckIsLastTaskComplete?ReviewId=" + this.ReviewId + "&DocId=" + DocId).subscribe(result => {
        if (result["Status"] != 1) {
        let  appCode = result["Data"].Application_Code;
        const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
        modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Review for document ' + documentname + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" }
        modalRef.result.then((result1) => {
          if (result1 == "okclick") {
            this.UpdateDocumentStatus(DocId, reviewtitle, result["Status"]);
            this.GetReviewDocuments();
            //this.modalRef.close('yes');
          }
        });
      }
    });
  }
  UpdateDocumentStatus(DocId: any, reviewtitle: any, IsLast: any) {
    if (IsLast == 2) {
      const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
      modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to Close the Review ' + reviewtitle + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" }
      modalRef.result.then((result) => {
        if (result == "okclick") {
          this.UpdateDocument_ReviewStatus(DocId);          
        }
      });
    }
    else {
      let formData = { "ReviewId":this.ReviewId ,"ReviewDocId": DocId ,"ApplicationCode":this.appCode 
        };     
        this.reviewService.UpdateDocumentStatus("api/Review/UpdateDocumentStatus", formData).subscribe(res => {
        if (res.Status == 0) {       
            this.commonService.SuccessBanner(res.Message);
            this.GetReviewDocuments();
        }
        else{
          this.commonService.ValidationBanner(res.Message);
        }    
      }); 
    }
  }

  UpdateDocument_ReviewStatus(DocId: any) {
    let formData = { "ReviewId":this.ReviewId ,"ReviewDocId": DocId ,"ApplicationCode":this.appCode 
  };     
  this.reviewService.UpdateDocument_ReviewStatus("api/Review/UpdateDocument_ReviewStatus", formData).subscribe(result => {
  if (result.Status == 0) {       
      this.commonService.SuccessBanner(result.Message);
      this.GetReviewDocuments();
  }
  else{
    this.commonService.ValidationBanner(result.Message);
  }    
}); 
}
}
